import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SensorOccupiedIcon(props: IconProps) {
    return <Icon {...props} iconKey={"sensor_occupied"}/>
}
